import { forEachSchemaNode } from '@framework/validation';
import { isRichTextSchema } from '../../../../inputs/rich-text-advanced/schema/RichTextAdvancedMeta';
import { debug } from '../../../../utils/debug';
import { IBaseWidget } from '../../../widgets/IBaseWidget';
import { WidgetRepository } from '../../../widgets/repository/WidgetRepository';
import { isReferenceSchema } from '../../validation/isReferenceSchema';
import { IReference, ReferenceType } from '../IReference';

export interface IVirtualReferencePaths {
  referencesPaths: string[];
  rtePaths: string[];
}

/**
 * Ottiene tutti i _path_ a Reference di tipo `VirtualColumn` presenti nel
 * widget.
 */
export function findVirtualReferencesInWidget(
  widget: IBaseWidget,
): IVirtualReferencePaths {
  const widgetType = WidgetRepository.find(widget.type);
  if (!widgetType?.configValidator) {
    return {
      referencesPaths: [],
      rtePaths: [],
    };
  }

  const referencesPaths: string[] = [];
  const rtePaths: string[] = [];

  forEachSchemaNode(widgetType.configValidator, { value: widget }, node => {
    const { schema } = node;
    if (isReferenceSchema(schema) && node.value != null) {
      if ((node.value as IReference).type === ReferenceType.VirtualColumn) {
        referencesPaths.push(node.path!);
      }
    } else if (isRichTextSchema(schema) && node.value != null) {
      rtePaths.push(node.path!);
    }
  });

  debug.log('virtualrefs.find', `Trovate ${referencesPaths.length} virtual refs in ${widget.id}`, { referencesPaths }); // prettier-ignore

  return { referencesPaths, rtePaths };
}
